import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoTooltip from 'components/InfoTooltip';
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { ReactComponent as AddNewField } from 'assets/icons/Group 239993.svg';
import TrashIcon from 'assets/icons/trash.svg';
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from "components";
import { DateTimePickerField } from "components/DateTime/DateTimePicker";
import {
  getDateTimeFormat,
  getDateTimeFormatForDatePicket,
  maskDateTime,
} from "helper/dateFormat";
import moment from "moment-timezone";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Select, { components } from "react-select";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { timeDuration } from "utils/durations";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import ClassUploadCoverImage from "./EventUploadCoverImage";
import Wysiwyg from "./Wysiwyg";
import MyButton from "components/MyButton";
import { fontConfig } from "theme/fontConfig";

const EventInfo = ({
  formik,
  coverImage,
  setCoverImage,
  handleOpenCoverImage,
  croppedImage,
}) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const [maxDate, setMaxDate] = useState("");
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
  const [loading, setLoading] = useState(false);

  const dateTimeMask = maskDateTime();

  useEffect(() => {
    // const currentDate = new Date();
    // const maxDate = new Date(
    //   currentDate.getFullYear() + 100,
    //   currentDate.getMonth(),
    //   currentDate.getDate()
    // );
    // setMaxDate(maxDate.toISOString().slice(0, 10));

    const maxDate = new Date();
    const maximumDate = maxDate.setFullYear(maxDate.getFullYear() + 100);
    setMaxDate(maximumDate);
  }, []);

  const minDate = getESTDateForPicker(new Date());

  // Always display and select in America/New_York (EST/EDT)
  function getESTDateForPicker(date) {
    if (!date) return null;
    // Convert UTC date string to America/New_York, then return a JS Date in that wall time
    const m = moment.tz(date, "UTC").tz("America/New_York");
    // Return a Date object with the correct wall time (but local timezone)
    return new Date(
      m.year(),
      m.month(),
      m.date(),
      m.hour(),
      m.minute(),
      m.second(),
      m.millisecond()
    );
  }

  // When user picks a date, treat it as America/New_York wall time, convert to UTC for storage
  function setESTDateToUTC(date, name) {
    if (!date) return null;
    // The date object is in local time, but we want to treat it as America/New_York
    const m = moment.tz(
      [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds(),
      ],
      "America/New_York"
    );
    const utcDate = m.utc().toDate();
    formik.setFieldValue(name, utcDate);
    return utcDate;
  }

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }

  const generateYearsHandler = () => {
    const currentYear = new Date().getFullYear();
    const yearsList = [];
    for (let i = 0; i <= 2; i++) {
      const year = currentYear + i;
      yearsList.push(year.toString());
      if (i < 2) {
        yearsList.push(`${year}-${year + 1}`);
      }
    }
    return yearsList;
  };

  const formatOptionLabel = ({ key, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{key}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
    height: "48px",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  const getMaxTimeRegistration = (dateToCompare, selectedDate) => {
    const convertedDateToCompare = getESTDateForPicker(dateToCompare);
    const convertedSelectedDate = getESTDateForPicker(selectedDate);
    let maxTime = moment().hours(23).minutes(59).seconds(59).toDate();
    if (moment(convertedSelectedDate).isSame(convertedDateToCompare, "day")) {
      const time = moment(convertedDateToCompare).format("HH:mm");
      if (time !== "00:00") {
        maxTime = moment(convertedDateToCompare)
          .subtract(30, "minutes")
          .toDate();
      } else {
        maxTime = convertedDateToCompare;
      }
    }
    return maxTime;
  };

  const getMinTimeRegistrationEnd = (eventStartDate, eventEndDate) => {
    const convertedStartDate = getESTDateForPicker(eventStartDate);
    const convertedEndDate = getESTDateForPicker(eventEndDate);

    let minTime = moment().hours(0).minutes(0).seconds(0).toDate();
    console.log(
      "moment(convertedStartDate).isSame(convertedEndDate, 'day')",
      moment(convertedStartDate).isSame(convertedEndDate, "day")
    );
    if (moment(convertedStartDate).isSame(convertedEndDate, "day")) {
      minTime = moment(convertedStartDate).add(30, "minutes").toDate();
    }
    console.log("minTime", minTime);
    return minTime;
  };

  const getMaxTimeRegistrationEnd = (date, eventEndDate) => {
    const convertedDate = getESTDateForPicker(date);
    const convertedSelectedEndDate = getESTDateForPicker(eventEndDate);
    let maxTime = moment().hours(23).minutes(59).seconds(59).toDate();
    if (moment(convertedSelectedEndDate).isSame(convertedDate, "day")) {
      const time = moment(convertedDate).format("HH:mm");
      if (time !== "00:00") {
        maxTime = moment(convertedDate).subtract(30, "minutes").toDate();
      } else {
        maxTime = convertedDate;
      }
    }
    return maxTime;
  };

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      )
    );
    formik.setFieldValue(name, date);
    return date;
  }

  return (
    <>
      <Row>
        <Col className="col-sm-12">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
            mandatory={true}
            {...{
              formik,
              title: "Event Name",
              name: "eventName",
              placeholder: "Event Name",
              checkValidation: true,
            }}
            value={formik.values?.eventName}
            handleChange={(e) => {
              formik.setFieldValue("eventName", e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
              if (e.key === " " && formik.values?.eventName === "") {
                e.preventDefault();
              }
            }}
            onBlur={formik.handleBlur}
            maxLength={30}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "40px" }} className="align-items-center">
        <Col className="col-sm-6" style={{ display: "flex", alignItems: "center", height: "48px", gap: "5px" }}>
          <MyCheckbox
            title="Multi Date Event"
            checked={formik.values?.multiDateEvent}
            handlechange={() => {
              if (formik.values?.hadParticipants) return;
              const enabling = !formik.values?.multiDateEvent;
              formik.setFieldValue("multiDateEvent", enabling);
              if (enabling) {
                if (!formik.values?.registrationType) {
                  formik.setFieldValue("registrationType", "group");
                }
                if (!(formik.values?.additionalEventDates?.length >= 1)) {
                  formik.setFieldValue("additionalEventDates", [
                    { date: null, eventDuration: { key: "30 min", value: 30 }, label: '' },
                  ]);
                }
              } else {
                formik.setFieldValue("additionalEventDates", []);
              }
            }}
            titleStyles={{ fontSize: "12px" }}
            disabled={formik.values?.hadParticipants}
          />
          <InfoTooltip text="Enable this if your event spans multiple dates. E.g., A multi-day holiday where each day is listed as a separate event occurrence." style={{ marginBottom: '4px' }} />
          <MyCheckbox
            title="Display Only"
            checked={formik.values?.displayOnly || false}
            handlechange={() => {
              if (formik.values?.hadParticipants) return;
              formik.setFieldValue("displayOnly", !formik.values?.displayOnly);
            }}
            titleStyles={{ fontSize: "12px" }}
            disabled={formik.values?.hadParticipants}
            style={{ marginLeft: '12px' }}
          />
          <InfoTooltip text="Events that do not require registration, such as Saturday services, but should still appear on the events calendar with a date, time, and location." style={{ marginBottom: '4px' }} />
        </Col>
        {!formik.values?.displayOnly && formik.values?.multiDateEvent && (
          <Col className="col-sm-6" style={formik.values?.hadParticipants ? { cursor: 'not-allowed', opacity: 0.6 } : {}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '0.25rem' }}>
              <label style={{ fontFamily: fontConfig.EventsEventInfoTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0, cursor: formik.values?.hadParticipants ? 'not-allowed' : 'default' }}>
                Multi Date Registration Method <span style={{ color: 'red' }}>*</span>
              </label>
              <InfoTooltip text="Group: All dates are bundled together, so one registration includes every occurrence. Example: A 4-week learning series where registering once signs the attendee up for all four classes. Individual: Each date is treated separately, so attendees can choose which specific dates they want to attend." />
            </div>
            <div className="gender_container" style={formik.values?.hadParticipants ? { pointerEvents: 'none', cursor: 'not-allowed' } : {}}>
              <div
                className={formik.values?.registrationType === "group" ? "gender genderActive" : "gender"}
                style={{ width: "50%" }}
                onClick={() => {
                  formik.setFieldValue("registrationType", "group");
                  formik.setFieldTouched("registrationType", true, false);
                }}
              >
                Group
              </div>
              <div
                className={formik.values?.registrationType === "individual" ? "gender genderActive" : "gender"}
                style={{ width: "50%" }}
                onClick={() => {
                  formik.setFieldValue("registrationType", "individual");
                  formik.setFieldTouched("registrationType", true, false);
                }}
              >
                Individual
              </div>
            </div>
            {formik.errors?.registrationType && (formik.touched?.registrationType || formik.submitCount > 0) && (
              <HintField error={formik.errors.registrationType} />
            )}
          </Col>
        )}
      </Row>
      {(() => {
        const additionalDates = formik.values?.additionalEventDates || [];
        const isMulti = formik.values?.multiDateEvent;
        const isLastFirstRow = additionalDates.length === 0;

        const getEndTime = (date, durationMinutes) => {
          if (!date || !durationMinutes) return null;
          return new Date(new Date(date).getTime() + durationMinutes * 60 * 1000);
        };

        // allRows[0] = primary, allRows[1..] = additionalDates
        const allRows = [
          { date: formik.values?.date, durationMinutes: formik.values?.eventDuration?.value },
          ...additionalDates.map(d => ({ date: d.date, durationMinutes: d.eventDuration?.value })),
        ];

        // rowOverlaps[i] = true when row i's end time exceeds row i+1's start time
        const rowOverlaps = isMulti
          ? allRows.map((row, idx) => {
              if (idx === allRows.length - 1) return false;
              if (!row.date || !row.durationMinutes || !allRows[idx + 1].date) return false;
              return getEndTime(row.date, row.durationMinutes) > new Date(allRows[idx + 1].date);
            })
          : allRows.map(() => false);

        const deleteRow = (i) => {
          const updated = [...additionalDates];
          updated.splice(i, 1);
          formik.setFieldValue("additionalEventDates", updated);
        };

        const addRow = () => {
          // Max 52 dates total (primary + additional)
          if (1 + additionalDates.length >= 52) {
            toastr.info("Validation", "Maximum of 52 dates allowed for a multi-date event.");
            return;
          }

          // Validate primary date row
          const primaryDateMissing = !formik.values?.date;
          const primaryDurationMissing = !formik.values?.eventDuration?.key;
          const primaryLabelMissing = !formik.values?.dateLabel;

          // Validate all additional date rows
          const additionalMissing = additionalDates.map((entry) => ({
            date: !entry.date,
            eventDuration: !entry.eventDuration?.key,
            label: !entry.label,
          }));

          const hasErrors =
            primaryDateMissing ||
            primaryDurationMissing ||
            primaryLabelMissing ||
            additionalMissing.some((e) => e.date || e.eventDuration || e.label);

          if (hasErrors) {
            if (primaryDateMissing) formik.setFieldTouched("date", true);
            if (primaryDurationMissing) formik.setFieldTouched("eventDuration", true);
            if (primaryLabelMissing) formik.setFieldTouched("dateLabel", true);
            additionalDates.forEach((_, i) => {
              if (additionalMissing[i].date)
                formik.setFieldTouched(`additionalEventDates[${i}].date`, true);
              if (additionalMissing[i].eventDuration)
                formik.setFieldTouched(`additionalEventDates[${i}].eventDuration`, true);
              if (additionalMissing[i].label)
                formik.setFieldTouched(`additionalEventDates[${i}].label`, true);
            });
            const missingFields = [];
            if (primaryDateMissing || additionalMissing.some((e) => e.date)) missingFields.push('Event Date/Hour');
            if (primaryDurationMissing || additionalMissing.some((e) => e.eventDuration)) missingFields.push('Duration');
            if (primaryLabelMissing || additionalMissing.some((e) => e.label)) missingFields.push('Label');
            toastr.info(
              "Validation",
              `Please fill in the following required fields: ${missingFields.join(', ')}.`
            );
            return;
          }

          formik.setFieldValue("additionalEventDates", [
            ...additionalDates,
            { date: null, eventDuration: { key: "30 min", value: 30 }, label: '' },
          ]);
        };

        return (
          <>
            <Row style={{ marginTop: "16px" }}>
              {isMulti && (
                <Col className="col-sm-6">
                  <InputField
                    titleStyle={{
                      fontFamily: fontConfig.GeneralInputFieldFont.family,
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: "#4F4F4F",
                    }}
                    mandatory={true}
                    checkValidation={true}
                    {...{
                      formik,
                      title: "Label",
                      name: "dateLabel",
                      placeholder: "Label",
                    }}
                    value={formik.values?.dateLabel || ''}
                    handleChange={(e) => {
                      const val = e.target?.value;
                      formik.setFieldTouched("dateLabel", true, false);
                      const norm = val.trim().toLowerCase();
                      (formik.values?.additionalEventDates || []).forEach((d, idx) => {
                        if (d?.label && d.label.trim().toLowerCase() === norm) {
                          formik.setFieldTouched(`additionalEventDates[${idx}].label`, true, false);
                        }
                      });
                      formik.setFieldValue("dateLabel", val);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") e.preventDefault();
                    }}
                    onBlur={formik.handleBlur}
                  />
                </Col>
              )}
              <Col className="col-sm-6">
                <DateTimePickerField
                  mandatory={true}
                  {...{
                    formik,
                    title: "Event Date/Hour ",
                    name: "date",
                  }}
                  checkValidation={true}
                  selected={
                    formik.values?.date && convertUTCToLocalDate(formik.values?.date)
                  }
                  onChange={(e) => {
                    let date = e;
                    if (e && isMulti && additionalDates[0]?.date && formik.values?.eventDuration?.value) {
                      const maxUtc = new Date(new Date(additionalDates[0].date).getTime() - formik.values.eventDuration.value * 60 * 1000);
                      const maxLocal = convertUTCToLocalDate(maxUtc);
                      if (moment(e).isSame(moment(maxLocal), 'day') && e > maxLocal) date = maxLocal;
                    }
                    formik.setFieldValue(`date`, date);
                    convertLocalToUTCDate(date, `date`);
                    formik.setFieldValue(`eventStartDate`, null);
                    formik.setFieldValue(`eventEndDate`, null);
                  }}
                  showTimeSelect={true}
                  dateFormat={getDateTimeFormatForDatePicket()}
                  placeholderText={getDateTimeFormat()}
                  mask={dateTimeMask}
                  minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                  maxDate={(() => {
                    if (!isMulti || !additionalDates[0]?.date || !formik.values?.eventDuration?.value) return undefined;
                    const maxUtc = new Date(new Date(additionalDates[0].date).getTime() - formik.values.eventDuration.value * 60 * 1000);
                    return convertUTCToLocalDate(maxUtc);
                  })()}
                  minTime={moment().hours(0).minutes(0).seconds(0).toDate()}
                  maxTime={(() => {
                    if (!isMulti || !additionalDates[0]?.date || !formik.values?.eventDuration?.value) {
                      return moment().hours(23).minutes(59).seconds(59).toDate();
                    }
                    const maxUtc = new Date(new Date(additionalDates[0].date).getTime() - formik.values.eventDuration.value * 60 * 1000);
                    const maxLocal = convertUTCToLocalDate(maxUtc);
                    const selectedLocal = formik.values?.date ? convertUTCToLocalDate(formik.values.date) : null;
                    if (selectedLocal && moment(selectedLocal).isSame(moment(maxLocal), 'day')) return maxLocal;
                    return moment().hours(23).minutes(59).seconds(59).toDate();
                  })()}
                  error={
                    formik.touched?.date && !formik.values?.date
                      ? 'Required'
                      : isMulti && rowOverlaps[0]
                      ? 'Event cannot overlap'
                      : ''
                  }
                />
              </Col>
              {!isMulti && (
                <Col className="col-sm-6">
                  <div className="pt-1 account-subtype-field">
                    <LabelField
                      title={"Event Duration"}
                      mandatory={true}
                      style={{
                        fontFamily: fontConfig.GeneralLabelFieldFont.family,
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "18px",
                        color: "#4F4F4F",
                        marginBottom: "0.25rem",
                      }}
                    />
                    <Select
                      {...{
                        formik,
                        name: `eventDuration`,
                        mandatory: true,
                        checkValidation: true,
                      }}
                      placeholder="Select Duration"
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={timeDuration()}
                      isLoading={loading}
                      styles={colourStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      onChange={(value) => {
                        formik.setFieldValue(`eventDuration`, {
                          key: value.key,
                          value: value.value,
                        });
                      }}
                      value={{
                        key: formik.values?.eventDuration?.key,
                        value: formik.values?.eventDuration?.value,
                      }}
                      components={{ DropdownIndicator }}
                    />
                    {formik.touched?.eventDuration && !formik.values?.eventDuration?.key && (
                      <HintField error="Required" />
                    )}
                  </div>
                </Col>
              )}
            </Row>
            {isMulti && (
              <>
                <Row style={{ marginTop: "0" }}>
                  <Col className="col-sm-6">
                    <div className="pt-1 account-subtype-field">
                      <LabelField
                        title={"Event Duration"}
                        mandatory={true}
                        style={{
                          fontFamily: fontConfig.GeneralLabelFieldFont.family,
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "18px",
                          color: "#4F4F4F",
                          marginBottom: "0.25rem",
                        }}
                      />
                      <Select
                        {...{
                          formik,
                          name: `eventDuration`,
                          mandatory: true,
                          checkValidation: true,
                        }}
                        placeholder="Select Duration"
                        classNamePrefix="react-select"
                        formatOptionLabel={formatOptionLabel}
                        options={timeDuration()}
                        isLoading={loading}
                        styles={colourStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onChange={(value) => {
                          formik.setFieldValue(`eventDuration`, {
                            key: value.key,
                            value: value.value,
                          });
                        }}
                        value={{
                          key: formik.values?.eventDuration?.key,
                          value: formik.values?.eventDuration?.value,
                        }}
                        components={{ DropdownIndicator }}
                      />
                      {formik.touched?.eventDuration && !formik.values?.eventDuration?.key && (
                        <HintField error="Required" />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: "12px", marginBottom: "16px" }}>
                  <Col className="col-sm-12">
                    <hr className="w-100" style={{ borderBottom: 'dashed 1px #002E5C', opacity: '0.2', margin: 0 }} />
                  </Col>
                </Row>
              </>
            )}
            {isMulti && isLastFirstRow && (
              <Row style={{ marginTop: "8px" }}>
                <Col className="col-sm-12 d-flex justify-content-end">
                  <button className="optional_type_add_btn" type="button" onClick={addRow}>
                    <AddNewField />
                    Add
                  </button>
                </Col>
              </Row>
            )}
            {isMulti && additionalDates.map((entry, i) => {
              const isLast = i === additionalDates.length - 1;
              return (
                <React.Fragment key={i}>
                <Row style={{ marginTop: "16px" }}>
                  <Col className="col-sm-6">
                    <InputField
                      titleStyle={{
                        fontFamily: fontConfig.GeneralInputFieldFont.family,
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "18px",
                        color: "#4F4F4F",
                      }}
                      mandatory={true}
                      checkValidation={true}
                      {...{
                        formik,
                        title: "Label",
                        name: `additionalEventDates[${i}].label`,
                        placeholder: "Label",
                      }}
                      value={entry.label || ''}
                      handleChange={(e) => {
                        const val = e.target?.value;
                        formik.setFieldTouched(`additionalEventDates[${i}].label`, true, false);
                        const norm = val.trim().toLowerCase();
                        if (formik.values?.dateLabel && formik.values.dateLabel.trim().toLowerCase() === norm) {
                          formik.setFieldTouched("dateLabel", true, false);
                        }
                        (formik.values?.additionalEventDates || []).forEach((d, idx) => {
                          if (idx !== i && d?.label && d.label.trim().toLowerCase() === norm) {
                            formik.setFieldTouched(`additionalEventDates[${idx}].label`, true, false);
                          }
                        });
                        const updated = [...additionalDates];
                        updated[i] = { ...updated[i], label: val };
                        formik.setFieldValue("additionalEventDates", updated);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </Col>
                  <Col className="col-sm-6" style={{ position: 'relative' }}>
                    <DateTimePickerField
                      mandatory={true}
                      {...{
                        formik,
                        title: "Event Date/Hour ",
                        name: `additionalEventDates[${i}].date`,
                      }}
                      checkValidation={true}
                      selected={entry.date && convertUTCToLocalDate(entry.date)}
                      onChange={(e) => {
                        let date = e;
                        if (e) {
                          const prevEndUtc = getEndTime(allRows[i].date, allRows[i].durationMinutes);
                          if (prevEndUtc) {
                            const prevEndLocal = convertUTCToLocalDate(prevEndUtc);
                            if (moment(e).isSame(moment(prevEndLocal), 'day') && e < prevEndLocal) date = prevEndLocal;
                          }
                          const nextDate = additionalDates[i + 1]?.date;
                          const dur = entry.eventDuration?.value;
                          if (nextDate && dur) {
                            const maxLocal = convertUTCToLocalDate(new Date(new Date(nextDate).getTime() - dur * 60 * 1000));
                            if (moment(date).isSame(moment(maxLocal), 'day') && date > maxLocal) date = maxLocal;
                          }
                        }
                        const updated = [...additionalDates];
                        updated[i] = { ...updated[i], date };
                        formik.setFieldValue("additionalEventDates", updated);
                        if (date) convertLocalToUTCDate(date, `additionalEventDates[${i}].date`);
                      }}
                      showTimeSelect={true}
                      dateFormat={getDateTimeFormatForDatePicket()}
                      placeholderText={getDateTimeFormat()}
                      mask={dateTimeMask}
                      minDate={(() => {
                        const prevEndUtc = getEndTime(allRows[i].date, allRows[i].durationMinutes);
                        return prevEndUtc ? convertUTCToLocalDate(prevEndUtc) : new Date(new Date().setDate(new Date().getDate() + 1));
                      })()}
                      maxDate={(() => {
                        const nextDate = additionalDates[i + 1]?.date;
                        const dur = entry.eventDuration?.value;
                        if (!nextDate || !dur) return undefined;
                        return convertUTCToLocalDate(new Date(new Date(nextDate).getTime() - dur * 60 * 1000));
                      })()}
                      minTime={(() => {
                        const prevEndUtc = getEndTime(allRows[i].date, allRows[i].durationMinutes);
                        if (!prevEndUtc) return moment().hours(0).minutes(0).seconds(0).toDate();
                        const prevEndLocal = convertUTCToLocalDate(prevEndUtc);
                        const selectedLocal = entry.date ? convertUTCToLocalDate(entry.date) : null;
                        if (selectedLocal && moment(selectedLocal).isSame(moment(prevEndLocal), 'day')) return prevEndLocal;
                        return moment().hours(0).minutes(0).seconds(0).toDate();
                      })()}
                      maxTime={(() => {
                        const nextDate = additionalDates[i + 1]?.date;
                        const dur = entry.eventDuration?.value;
                        if (!nextDate || !dur) return moment().hours(23).minutes(59).seconds(59).toDate();
                        const maxLocal = convertUTCToLocalDate(new Date(new Date(nextDate).getTime() - dur * 60 * 1000));
                        const selectedLocal = entry.date ? convertUTCToLocalDate(entry.date) : null;
                        if (selectedLocal && moment(selectedLocal).isSame(moment(maxLocal), 'day')) return maxLocal;
                        return moment().hours(23).minutes(59).seconds(59).toDate();
                      })()}
                      error={
                        formik.touched?.additionalEventDates?.[i]?.date && !entry.date
                          ? 'Required'
                          : rowOverlaps[i + 1]
                          ? 'Event cannot overlap'
                          : undefined
                      }
                    />
                    {i >= 1 && (
                      <div
                        onClick={() => deleteRow(i)}
                        style={{
                          position: 'absolute',
                          right: '-28px',
                          top: '46px',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      >
                        <img src={TrashIcon} alt="delete" />
                      </div>
                    )}
                  </Col>
                </Row>
                <Row style={{ marginTop: "0" }}>
                  <Col className="col-sm-6">
                    <div className="pt-1 account-subtype-field">
                      <LabelField
                        title={"Event Duration"}
                        mandatory={true}
                        style={{
                          fontFamily: fontConfig.GeneralLabelFieldFont.family,
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "18px",
                          color: "#4F4F4F",
                          marginBottom: "0.25rem",
                        }}
                      />
                      <Select
                        placeholder="Select Duration"
                        classNamePrefix="react-select"
                        formatOptionLabel={formatOptionLabel}
                        options={timeDuration()}
                        isLoading={loading}
                        styles={colourStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onChange={(value) => {
                          const updated = [...additionalDates];
                          updated[i] = { ...updated[i], eventDuration: { key: value.key, value: value.value } };
                          formik.setFieldValue("additionalEventDates", updated);
                        }}
                        value={entry.eventDuration ? { key: entry.eventDuration.key, value: entry.eventDuration.value } : null}
                        components={{ DropdownIndicator }}
                      />
                      {formik.touched?.additionalEventDates?.[i]?.eventDuration && !entry.eventDuration?.key && (
                        <HintField error="Required" />
                      )}
                    </div>
                  </Col>
                </Row>
                {!isLast && (
                  <Row style={{ marginTop: "12px", marginBottom: "16px" }}>
                    <Col className="col-sm-12">
                      <hr className="w-100" style={{ borderBottom: 'dashed 1px #002E5C', opacity: '0.2', margin: 0 }} />
                    </Col>
                  </Row>
                )}
                {isLast && (
                  <Row style={{ marginTop: "16px" }}>
                    <Col className="col-sm-12 d-flex justify-content-end">
                      <button className="optional_type_add_btn" type="button" onClick={addRow}>
                        <AddNewField />
                        Add
                      </button>
                    </Col>
                  </Row>
                )}
                </React.Fragment>
              );
            })}
          </>
        );
      })()}
      {!formik.values?.displayOnly && <Row className="align-items-baseline">
        <Col className="col-sm-6" style={{ marginTop: "40px" }}>
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: "Registration Starts (EST)",
              name: "eventStartDate",
            }}
            checkValidation={true}
            selected={
              formik.values?.eventStartDate &&
              getESTDateForPicker(formik.values?.eventStartDate)
            }
            onChange={(e) => {
              setESTDateToUTC(e, `eventStartDate`);
              formik.setFieldValue(`eventEndDate`, null);
            }}
            minDate={minDate}
            maxDate={
              formik.values?.date
                ? moment(getESTDateForPicker(formik.values?.date))
                    .subtract(1, "minutes")
                    .toDate()
                : minDate
            }
            minTime={moment().hours(0).minutes(0).seconds(0).toDate()}
            maxTime={
              formik.values?.date
                ? getMaxTimeRegistration(
                    formik.values?.date,
                    formik.values?.eventStartDate
                  )
                : moment().hours(23).minutes(59).seconds(59).toDate()
            }
            showTimeSelect={true}
            dateFormat={getDateTimeFormatForDatePicket()}
            placeholderText={getDateTimeFormat()}
            mask={dateTimeMask}
            disabled={!formik.values?.date}
            error={formik.touched?.eventStartDate && !formik.values?.eventStartDate ? 'Required' : ''}
          />
        </Col>
        <Col className="col-sm-6" style={{ marginTop: "40px" }}>
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: "Registration Ends (EST)",
              name: "eventEndDate",
            }}
            checkValidation={true}
            selected={
              formik.values?.eventEndDate &&
              getESTDateForPicker(formik.values?.eventEndDate)
            }
            onChange={(e) => {
              if (!e) {
                formik.setFieldValue("eventEndDate", null);
                return;
              }

              let finalEndDate = e;

              if (formik.values?.eventStartDate) {
                const startLocalDate = getESTDateForPicker(
                  formik.values.eventStartDate
                );

                if (moment(e).isSame(moment(), "day")) {
                  finalEndDate = moment(e)
                    .set({
                      hour: moment(e).hour(),
                      minute: moment(e).minute(),
                      second: moment(e).second(),
                    })
                    .toDate();
                }
              }

              if (
                formik.values?.eventStartDate &&
                moment(finalEndDate).isBefore(
                  moment(getESTDateForPicker(formik.values.eventStartDate))
                )
              ) {
                finalEndDate = moment(
                  getESTDateForPicker(formik.values.eventStartDate)
                )
                  .add(30, "minutes")
                  .toDate();
              }

              formik.setFieldValue("eventEndDate", finalEndDate);
              setESTDateToUTC(finalEndDate, "eventEndDate");
            }}
            disabled={!formik.values?.eventStartDate}
            minDate={
              formik.values?.eventStartDate
                ? getESTDateForPicker(formik.values?.eventStartDate)
                : minDate
            }
            maxDate={(() => {
              const allDates = [
                formik.values?.date,
                ...(formik.values?.multiDateEvent ? (formik.values?.additionalEventDates || []).map(d => d.date) : []),
              ].filter(Boolean);
              if (allDates.length > 0) {
                const lastDate = new Date(Math.max(...allDates.map(d => new Date(d).getTime())));
                const lastLocal = convertUTCToLocalDate(lastDate);
                return new Date(lastLocal.getFullYear(), lastLocal.getMonth(), lastLocal.getDate() + 1, 23, 59, 59);
              }
              return minDate;
            })()}
            minTime={
              formik.values?.eventStartDate
                ? getMinTimeRegistrationEnd(
                    formik.values?.eventStartDate,
                    formik.values?.eventEndDate
                  )
                : moment().hours(0).minutes(0).seconds(0).toDate()
            }
            maxTime={
              formik.values?.date
                ? getMaxTimeRegistrationEnd(
                    formik.values?.date,
                    formik.values?.eventEndDate
                  )
                : moment().hours(23).minutes(59).seconds(59).toDate()
            }
            showTimeSelect={true}
            dateFormat={getDateTimeFormatForDatePicket()}
            placeholderText={getDateTimeFormat()}
            mask={dateTimeMask}
            error={formik.touched?.eventEndDate && !formik.values?.eventEndDate ? 'Required' : ''}
          />
        </Col>
      </Row>}
      {!formik.values?.displayOnly && <div
        className="d-flex flex-wrap"
        style={{ marginTop: "2px", gap: "30px" }}
      >
        <div
          className=""
          style={
            !orgDetails?.memberPortal
              ? { opacity: "0.5", cursor: "not-allowed" }
              : {}
          }
        >
          <MyCheckbox
            title="Open to non-members"
            checked={formik.values?.allowNonMembers}
            handlechange={() => {
              formik.setFieldValue(
                "allowNonMembers",
                !formik.values?.allowNonMembers
              );
            }}
            titleStyles={{
              fontSize: "12px",
            }}
            disabled={!orgDetails?.memberPortal}
          />
        </div>
        {/* <div className="">
          <MyCheckbox
            title="Allow wait-list"
            checked={formik.values?.allowWaitingList}
            handlechange={() => {
              formik.setFieldValue(
                'allowWaitingList',
                !formik.values?.allowWaitingList
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
          />
        </div> */}
        <div className="">
          <MyCheckbox
            title="Allow bill my account"
            checked={formik.values?.allowBillMyAccount}
            handlechange={() => {
              formik.setFieldValue(
                "allowBillMyAccount",
                !formik.values?.allowBillMyAccount
              );
            }}
            titleStyles={{
              fontSize: "12px",
            }}
          />
        </div>
      </div>}
      <Row>
        <Col className="col-sm-12" style={{ marginTop: "40px" }}>
          <LabelField
            title="Description"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
          />
          <Wysiwyg formik={formik} />
        </Col>
      </Row>
      {!formik.values?.displayOnly && <Row style={{ marginBottom: '40px', marginTop: '40px' }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <label style={{ fontFamily: fontConfig.EventsEventInfoTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Button Label <span style={{ color: 'red' }}>*</span></label>
            <InfoTooltip text="Customize the call-to-action button text shown on the event registration page. E.g., 'Register Now', 'Book My Spot', or 'Join Us' (max 20 characters)." />
          </div>
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            maxLength={20}
            {...{
              formik,
              title: 'none',
              name: 'eventDetails.actionButtonLabel',
              placeholder: 'Button Label (Max. 20 characters)',
              checkValidation: true,
            }}
            value={formik.values?.eventDetails?.actionButtonLabel}
            handleChange={(e) => {
               const value = e.target?.value;
              if (value.length <= 20) {
                formik.setFieldValue('eventDetails.actionButtonLabel', e.target?.value);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.actionButtonLabel === '') {
                e.preventDefault();
              }
            }}
           onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '30px' }}>

         <MyButton
            content={
              formik.values?.eventDetails?.actionButtonLabel
            }

            style={{
              paddingLeft:'8px',
              paddingRight:'8px',
              minWidth: '96px',
              height: '36px',
             }}
          />
        </Col>
      </Row>}
      <Row>
        <Col className="col-sm-12" style={{ marginTop: "40px" }}>
          <LabelField
            title="Upload Cover Image (Max allowed is 5MB) (Min Image Dimension: 800x800)"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
          />
          <ClassUploadCoverImage
            coverImageFile={coverImage?.name}
            handleOpenCoverImage={handleOpenCoverImage}
            croppedImage={croppedImage}
          />
        </Col>
      </Row>
    </>
  );
};

export default EventInfo;
